<template>
    <div>
        <div v-if="showType == 0" class="dialog-description">
            <table>
                <tr>
                    <td colspan="2" v-t="'message.title_import_errorInfo'"></td>
                </tr>
                <tr>
                    <td v-t="'message.item_importType'"></td>
                    <td style="padding-left:20px">{{ getImportType(returnInfo.importType) }}</td>
                </tr>
                <tr>
                    <td v-t="'message.item_fileName'"></td>
                    <td style="padding-left:20px">{{ returnInfo.csvFileName }}</td>
                </tr>
                <tr>
                    <td colspan="2" v-t="'message.desc_import_errorInfo_note'"></td>
                </tr>
            </table>
        </div>
        <div v-else class="dialog-description" v-html="$t('message.desc_import_errorInfo')"/>
        <br>
        <table width="100%">
            <thead>
                <tr class="error-record-title">
                    <td class="error-record-number" v-t="'message.item_line_number'"></td>
                    <td class="error-record-detail" v-t="'message.item_error_information'"></td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(errorLine,lineindex) in returnInfo.errorLineInfo" :class="{ 'error-record': ((lineindex % 2) == 0) , 'error-record-thick': ((lineindex % 2) != 0) }">
                    <td class="error-record-number"> {{ errorLine.lineNo }}</td>
                    <td class="error-record-detail">
                        <span v-for="(errorCode , index) in errorLine.errorCodeList">
                            <span v-if="errorCodeIsInvalidUtf8(errorCode)">
                                {{ getErrorDescription(errorCode) }}<br>
                                {{ getGuidanceOfInvalidUtf8() }}
                            </span>
                            <span v-else-if="index == 0">
                                {{ getErrorDescription(errorCode) }}
                            </span>
                            <span v-else>
                                &nbsp;|&nbsp; {{ getErrorDescription(errorCode) }}
                            </span>
                        </span>
                        <span v-if="errorLine.errorParamList.length > 0">
                            <span v-if="errorLine.errorCodeList.length > 1">&nbsp;|&nbsp;</span>
                            (
                            <span v-for="(errorParam , index) in errorLine.errorParamList">
                                <span v-if="index == 0">
                                    {{ errorParam }}
                                </span>
                                <span v-else>
                                    &nbsp;,&nbsp; {{ errorParam }}
                                </span>
                            </span>
                            )
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import constants from './constants.js';
import commonUtil from './commonutil.js';

export default {
    data() {
        return {
        };
    },
    created: function() {
    },
    methods: {
        getErrorDescription(errorCode) {
            switch(errorCode) {
                case constants.STATUS_ERROR_INVALID_PARAMETER:
                    return commonUtil.getMessageText(this.$i18n,"error_csv_parameter");
                case constants.STATUS_ERROR_DENIED:
                    return commonUtil.getMessageText(this.$i18n,"error_csv_access_denied");
                case constants.STATUS_ERROR_ALREADY_EXISTED:
                    return commonUtil.getMessageText(this.$i18n,"error_csv_duplicateId");
                case constants.STATUS_ERROR_TOO_MANY_ENTRY:
                     return commonUtil.getMessageText(this.$i18n,"error_csv_exceeds_data");
                case constants.STATUS_ERROR_NOT_FOUND:
                    return commonUtil.getMessageText(this.$i18n,"error_csv_not_found");
                 case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                    return commonUtil.getMessageText(this.$i18n,"error_csv_object_not_found");
                case constants.STATUS_ERROR_PARENT_NOT_FOUND:
                    return commonUtil.getMessageText(this.$i18n,"error_csv_invalid_layerId");
                case constants.STATUS_ERROR_INVALID_PASSWORD_FORMAT:
                    return commonUtil.getMessageText(this.$i18n,"error_csv_invalid_password");
                case constants.STATUS_ERROR_INVALID_USER_OPTION:
                    return commonUtil.getMessageText(this.$i18n,"error_csv_invalid_option");
                case constants.STATUS_ERROR_LICENSE_INSUFFICIENT:
                    return commonUtil.getMessageText(this.$i18n,"error_csv_insufficient_license");
                case constants.STATUS_ERROR_OPTION_LICENSE_INSUFFICIENT:
                    return commonUtil.getMessageText(this.$i18n,"error_csv_insufficient_option");
                case constants.STATUS_ERROR_INVALID_DISPLAYNAME:
                    return commonUtil.getMessageText(this.$i18n,"error_csv_invalid_displayName");
                case constants.STATUS_ERROR_USER_NOT_FOUND:
                    return commonUtil.getMessageText(this.$i18n,"error_csv_invalid_userId");
                case constants.STATUS_ERROR_TALKGROUP_NOT_FOUND:
                    return commonUtil.getMessageText(this.$i18n,"error_csv_invalid_groupId");
                case constants.STATUS_ERROR_OPTION_UNMATCH:
                    return commonUtil.getMessageText(this.$i18n,"error_csv_option_unmatch");
                case constants.STATUS_ERROR_USER_EXISTS:
                    return commonUtil.getMessageText(this.$i18n,"error_csv_option_cannot_changed");
                case constants.STATUS_ERROR_INVALID_ORGANIZATION:
                    return commonUtil.getMessageText(this.$i18n,"error_csv_invalid_organization");
                case constants.STATUS_ERROR_INVALID_TITLE:
                    return commonUtil.getMessageText(this.$i18n,"error_csv_invalid_title");
                case constants.STATUS_ERROR_INVALID_PHONE_NUMBER:
                     return commonUtil.getMessageText(this.$i18n,"error_csv_invalid_phoneNumber");
                case constants.STATUS_ERROR_INVALID_EMAIL:
                    return commonUtil.getMessageText(this.$i18n,"error_csv_invalid_email");
                case constants.STATUS_ERROR_INVALID_SAVE_TALKRECORD:
                     return commonUtil.getMessageText(this.$i18n,"error_csv_invalid_save_talkRecord");
                 case constants.STATUS_ERROR_INVALID_SAVE_LIVECAST:
                     return commonUtil.getMessageText(this.$i18n,"error_csv_invalid_save_livecast");
                case constants.STATUS_ERROR_INVALID_DURATION_LIMIT:
                    return commonUtil.getMessageText(this.$i18n,"error_csv_invalid_talkTimer");
                case constants.STATUS_ERROR_EXCEEDS_MAX_COUNT:
                     return commonUtil.getMessageText(this.$i18n,"error_csv_exceeds_limit");
                case constants.STATUS_ERROR_EXCEEDS_MANDATORY_LIMIT:
                     return commonUtil.getMessageText(this.$i18n,"error_csv_exceeds_mandatory");
                case constants.STATUS_ERROR_INVALID_CSV_TEMPLATE:
                     return commonUtil.getMessageText(this.$i18n,"error_csv_invalid_template");
                case constants.STATUS_ERROR_USER_HAS_EXPORTED:
                     return commonUtil.getMessageText(this.$i18n,"error_csv_user_has_exported");
                case constants.STATUS_ERROR_INVALID_UTF8:
                     return commonUtil.getMessageText(this.$i18n,"error_csv_invalid_utf8");
                case constants.STATUS_ERROR_INVALID_CSV_FORMAT:
                     return commonUtil.getMessageText(this.$i18n,"error_csv_invalid_csv_format");
                case constants.STATUS_ERROR_INVALID_SUBGROUP_ID:
                     return commonUtil.getMessageText(this.$i18n,"error_csv_invalid_subGroupId");
                case constants.STATUS_ERROR_UNDELETABLE_OBJECT:
                     return commonUtil.getMessageText(this.$i18n,"error_csv_undeletable_object");
                case constants.STATUS_ERROR_MULTI_AND_INTERRUPT_SIMULTANEOUSLY:
                     return commonUtil.getMessageText(this.$i18n,"error_multi_and_interrupt_simultaneously");
                case constants.STATUS_ERROR_STILL_ASSIGNED:
                    return commonUtil.getMessageText(this.$i18n,"error_csv_join_group");
                case constants.STATUS_ERROR_BELL_ASSIGNED:
                    return commonUtil.getMessageText(this.$i18n,"error_csv_bell_target_assigned_group");
                case constants.STATUS_ERROR_NO_MORE_FREE_SLOT:
                    return commonUtil.getMessageText(this.$i18n,"error_csv_exceeds_free_slot");
                case constants.STATUS_ERROR_BELL_AUTH_USER_LIMIT:
                    return commonUtil.getMessageText(this.$i18n,"error_csv_bell_auth_user_limit");
                case constants.STATUS_ERROR_BELL_CSV_INVALID_TIMEZONE_HEADER:
                    return commonUtil.getMessageText(this.$i18n,"error_csv_invalid_bell_timezone_header");
                default:
                    return commonUtil.getMessageText(this.$i18n,"error_csv_unknown").replace("{errorCode}",errorCode);
            }
        },
        getImportType(importType) {
            switch(importType) {
                case constants.CSV_USER:
                    return commonUtil.getMessageText(this.$i18n,"item_user");
                case constants.CSV_GROUP:
                    return commonUtil.getMessageText(this.$i18n,"item_group");
                case constants.CSV_USER_GROUP:
                    return commonUtil.getMessageText(this.$i18n,"title_userGroup");
                case constants.CSV_BELL:
                    return commonUtil.getMessageText(this.$i18n,"item_bell");
                case constants.CSV_BELL_AUTH_USER:
                    return commonUtil.getMessageText(this.$i18n,"item_bell_auth_user");
            }
        },
        errorCodeIsInvalidUtf8(errorCode) {
            return (errorCode == constants.STATUS_ERROR_INVALID_UTF8)
        },
        getGuidanceOfInvalidUtf8() {
            let guidanceIdendifierText = "error_csv_invalid_utf8_guidance";
            return commonUtil.getMessageText(this.$i18n, guidanceIdendifierText);
        }
    },
    props: [ 'returnInfo' , 'showType' ]
}
</script scoped>

<style scoped>
tbody {
    display: block;
    height: 460px;
    overflow-y: scroll;
}

thead, tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
}

.error-record-title {
    width: 100%;
    padding-top: 10px;
    padding-bottom: 10px;
    display: block;
    background-color: #f6f6f6
}
.error-record {
    width: 100%;
    border-bottom:1px #eee solid;
    padding-top: 10px;
    padding-bottom: 10px;
    display: block;
}
.error-record-thick {
    width: 100%;
    border-bottom:1px #eee solid;
    padding-top: 10px;
    padding-bottom: 10px;
    display: block;
    background-color: #fafafa;
}
.error-record-number {
    width: 80px;
    padding-left: 10px;
}
.error-record-detail {
    padding-left: 10px;
}
.dialog-description {
    padding-top: 16px;
    display: block;
}

</style>
